<template>
    <div class="field is-horizontal">
        <div class="field-label is-normal">
            <label class="label">Allocated Cred.</label>
        </div>
        <div class="field-body">
            <div class="field">
                <div class="control has-icons-left">
                    <input class="input" type="text" v-model="allocated_credit" placeholder="Allocated Credit" :class="{ 'is-danger': errors.allocated_credit }">
                    <span class="icon is-left">
                        <i class="fas fa-wallet"></i>
                    </span>
                    <p v-if="errors.allocated_credit" class="help is-danger">{{ errors.allocated_credit[0] }}</p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                countries: []
            }
        },
        computed: {
            allocated_credit: {
                get() {
                    return this.$store.getters.getNewPricePlan.allocated_credit
                },
                set(value) {
                    this.$store.dispatch('setNewPricePlanFieldValue', {field: 'allocated_credit', value: value})
                }
            },
            errors() {
                return this.$store.getters.getNewPricePlanErrors
            }
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/ControlPanel/PricePlans/NewPlan/Inputs/AllocatedCreditInput.vue